import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b91d793"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-account-input__info" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "search-account-input__info-icon"
}
const _hoisted_4 = { class: "search-account-input__info-name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "search-account-input__title" }, "To", -1))
const _hoisted_6 = ["size"]

import DropdownWrapper from "@/components/dropdown-wrapper/index.vue";
import AccountSelect from "@/components/account-select/index.vue";
import { Account } from "@/types/account";
import { PropType, ref, computed, ComponentPublicInstance } from "vue";
import { onClickOutside } from "@vueuse/core";
import { formatAddress } from "@/utils/filters";
import createIcon from "@/libs/identicon/polkadot";
import { encodeSubstrateAddress } from "@/utils";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  account: {
    type: Object as PropType<Account | null>,
    default: null,
  },
  accounts: {
    type: Object as PropType<Array<Account>>,
    default: () => ({}),
  },
  recent: {
    type: Object as PropType<Array<Account>>,
    default: () => ({}),
  },
},
  emits: ["update:select"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const isOpenDropdown = ref<boolean>(false);
const isFocus = ref<boolean>(false);
const container = ref(null);
const dropdown = ref(null);
const inputRef = ref<ComponentPublicInstance<HTMLInputElement>>();
__expose({ inputRef });





const addressValue = computed({
  get: () => {
    try {
      const auxAddress = props.account?.address || "";
      if (isFocus.value && isAddress.value) {
        return auxAddress;
      } else if (isAddress.value) {
        return props.account?.name ? props.account.name : auxAddress;
      }

      return auxAddress;
    } catch {
      return props.account?.address || "";
    }
  },
  set: (value) => {
    if (value) {
      const isValidAddress = encodeSubstrateAddress(value);
      const formatted = isValidAddress ? formatAddress(value) : value;
      const name =
        props.accounts.find((item) => item.address === formatted)?.name || "";

      emit("update:select", {
        id: Number.MAX_SAFE_INTEGER,
        name,
        address: formatted,
        image: isValidAddress ? createIcon(value) : undefined,
        isLedger: false,
      });
    }
  },
});

const isAddress = computed(() => {
  return !!encodeSubstrateAddress(props.account?.address);
});

const size = computed(() => {
  if (props.account == null) return 1;
  return props.account.name ? props.account.name.length : 1;
});

const openAccounts = () => {
  isOpenDropdown.value = true;
};

const closeAccounts = () => {
  isOpenDropdown.value = false;
};

const changeFocus = (val: FocusEvent) => {
  isFocus.value = val.type === "focus";
  if (isFocus.value) openAccounts();
};

const selectAccount = (account: Account) => {
  emit("update:select", account);
  closeAccounts();
};

const focus = () => {
  if (inputRef.value) inputRef.value.focus();
};

onClickOutside(container, () => {
  isFocus.value = false;
  closeAccounts();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "container",
    ref: container,
    class: "search-account-input"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.account?.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.account.image
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("div", _hoisted_3)),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          ref_key: "inputRef",
          ref: inputRef,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addressValue).value = $event)),
          type: "text",
          class: _normalizeClass(["search-account-input__input", { sized: size.value != 1 && !isFocus.value }]),
          placeholder: "Search or paste Polkadot address",
          style: _normalizeStyle({ color: !isAddress.value ? 'red' : 'black' }),
          size: size.value,
          onFocus: changeFocus,
          onBlur: changeFocus
        }, null, 46, _hoisted_6), [
          [_vModelText, addressValue.value]
        ]),
        (size.value != 1 && !isFocus.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "search-account-input__address",
              onClick: focus
            }, _toDisplayString(_ctx.$filters.replaceWithEllipsis(__props.account?.address, 6, 6)), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (isOpenDropdown.value)
      ? (_openBlock(), _createBlock(DropdownWrapper, {
          key: 0,
          ref_key: "dropdown",
          ref: dropdown
        }, {
          default: _withCtx(() => [
            _createVNode(AccountSelect, {
              accounts: __props.accounts,
              recent: __props.recent,
              "onUpdate:selectAccount": selectAccount
            }, null, 8, ["accounts", "recent"])
          ]),
          _: 1
        }, 512))
      : _createCommentVNode("", true)
  ], 512))
}
}

})